export enum AssignedAppTypeEnum {
    Default = 'Default',
    Amr = 'Amr',
}
